import { inject, Injectable, Injector } from '@angular/core';
import { DataLoaderService } from './data-loader.service';
import type { SentryService } from './sentry.service';

@Injectable({
  providedIn: 'root',
})
export class LazyLoadedSentryService {
  private injector = inject(Injector);
  private loader = inject(DataLoaderService);

  load(): Promise<SentryService> {
    return this.loader.get('lazy-loaded-sentry-service', () => {
      return new Promise(resolve => {
        import('./sentry.service').then(({ SentryService }) => {
          const service = this.injector.get(SentryService);
          resolve(service);
        });
      });
    });
  }
}
